require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./quarterlynewslettermarch-2021.json") })
        }
      }, "path---quarterlynewslettermarch-2021");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---quarterlynewslettermarch-2021!./.cache/json/quarterlynewslettermarch-2021.json
// module id = 1203
// module chunks = 231608221292675